import { Injectable, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { DepositSearchResult } from "../../models/depositSearchResult.model";
import { ZeroDollarCheckDeposit } from "../../models/zerodollarcheckdeposit.model";
import { BaseService } from "../api-base.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class CreateZeroDollarRemittanceService implements OnInit {
  private readonly timeout: number = 30000;
  private readonly basePath: string = "Remittance";

  ngOnInit(): void {}

  constructor(private http: HttpClient, private apiBase: BaseService) {}

  public async createZeroDollarRemittance(
    clientId: string,
    checkRefNumber: number,
    zeroDollarCheckDeposit: ZeroDollarCheckDeposit
  ): Promise<DepositSearchResult> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/Checks/${checkRefNumber}/ZeroDollarChecks/`;

    const response = await this.http
      .post<DepositSearchResult>(
        url,
        zeroDollarCheckDeposit,
        { headers: this.apiBase.getHeaders() }
      )
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} with status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
      });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remittance-entry/create-zerodollar-remittance.service.ts